import { HeadingComponentConfig } from '../heading';

export interface SidenavHeader {
    avatarImageUrl: string;
    title: HeadingComponentConfig;
    subtitle: HeadingComponentConfig;
}
